/**
 * Connects the shared `ErpEnvironmentBanner` to the extranet data layer.
 *
 * A tenant has one registry per VEOS environment (recette, preprod, prod),
 * all linked to the module — so the banner is fed only the registry the user
 * logged into (`registrySlug`). Otherwise a production login would still
 * raise the banner because of the tenant's recette/preprod registries. When
 * that registry is not in the list (unknown slug), every registry is passed:
 * the banner's safety property ("no banner ⇒ production") is preserved.
 *
 * While loading — or if the fetch fails — it renders nothing rather than
 * guessing an environment. Pure chrome, not registered.
 */

import { useMemo } from 'react';

import { ErpEnvironmentBanner } from '@/shared/erp';

import { useExtranetAuthStore } from '../auth/store';
import { useExtranetErpRegistries } from '../hooks/useExtranetErpRegistries';

export function ExtranetEnvironmentBanner() {
  const { data } = useExtranetErpRegistries();
  const registrySlug = useExtranetAuthStore((s) => s.registrySlug);

  const registries = useMemo(() => {
    const all = data ?? [];
    const active = all.filter((registry) => registry.slug === registrySlug);
    return active.length > 0 ? active : all;
  }, [data, registrySlug]);

  return <ErpEnvironmentBanner registries={registries} />;
}
